import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Roles } from '../../constant/roles';
import { UserStore } from '../../store/user.store';

@Injectable({
    providedIn: 'root'
})
export class CheckJira implements CanLoad, CanActivate {
    constructor(private router: Router, private usrStore: UserStore) {
    }

    async canLoad() {
        console.log('CheckJira');
        if (this.usrStore.userLogged.roles?.includes(Roles.JIRA))
            return true;
        else
            return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        console.log('CheckJira => check canActivate');
        if (this.usrStore.userLogged?.roles?.includes(Roles.JIRA))
            return true;
        else
            return false;
    }
}
